import { api } from '@/api/client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { TaxRateDto } from './useTaxRates';

interface UpdateTaxRateInput {
  id: string;
  patch: {
    rate?: number | undefined;
    description?: string | undefined;
    legalRef?: string | undefined;
    validTo?: string | undefined;
  };
}

export function useUpdateTaxRate() {
  const queryClient = useQueryClient();
  return useMutation<TaxRateDto, Error, UpdateTaxRateInput>({
    mutationFn: async ({ id, patch }) => {
      const res = await api.patch<{ data: TaxRateDto }>(`/api/v1/payroll/tax-rates/${id}`, patch);
      return res.data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['payroll', 'tax-rates'] });
    },
  });
}
